// extracted by mini-css-extract-plugin
export var completionBody = "_cv-2";
export var completionCard = "_cv-0";
export var completionFooter = "_cv-3";
export var completionTitle = "_cv-1";